<template>
	<div class="test_result_structure">
		<pre class="doc_main_pre"><code class="doc_main_code">// 检测结果结构体
struct CFaceStruct
{
   int nFaceRX1;                     // 人脸矩形左上点X
   int nFaceRY1;                     // 人脸矩形左上点Y
   int nFaceRX2;                     // 人脸矩形右上点X
   int nFaceRY2;                     // 人脸矩形右上点Y
   int nFaceRX3;                     // 人脸矩形右下点X
   int nFaceRY3;                     // 人脸矩形右下点Y
   int nFaceRX4;                     // 人脸矩形左下点X
   int nFaceRY4;                     // 人脸矩形左下点Y
   int nFaceRectSX;                // 人脸正方形起始点X
   int nFaceRectSY;                // 人脸正方形起始点Y
   int nFaceSize;                     // 人脸正方形边长
   int nTrackID;                        // 人脸追踪ID(随机值，主要用于跟踪标记)
   float fImageQuality;             // 人脸图像品质(0.0 - 1.0),大于0.7则表示人脸特征有效
   int nUpdate;                         // 人脸图像可识别更新情况,主要用于人脸跟踪.0:不建议更新,1:建议更新
   int nPitch;                            // 抬头低头欧拉角[-90,-90],在[-30,30]范围内进行人脸特征提取有效
   int nRoll;                              // 人脸面内旋转欧拉角[-180,180],360全角度进行人脸特征提取有效
   int nYaw;                             // 左右转动欧拉角[-90,90],在[-45,45]范围内进行人脸特征提取有效
   int nFaceDistance;              // 人脸距离,小于0则表示无效(未检测到距离)
   char szPersonID[PERSON_ID_LEN];   // 人员ID
   char szName[PERSON_NAME_LEN];     // 人员姓名
   int nAge;                              // 年龄,小于0表示不清楚
   int nSex;                              // 性别,0:不清楚;1:女性;2:男性
   int nGlasses;                       // 是否带眼镜,小于0表示不清楚,0:不戴眼镜;1:戴眼镜;2:太阳镜;
   //char szFeature[PERSON_FEATURE_LEN + 1];       // 人脸特征值,经过Base64后的长度，已废弃
   unsigned char szBinFeature[PERSON_FEATURE_BIN_LEN]; // 人脸特征值，未经过base64加密
   float arrKeyPoint[144];        // 人脸关键点信息(共72个关键点，先X后Y),[企业版提供]
};
#endif</code></pre>
	</div>
</template>
<script>
	export default{
		// props: {
  //           pathData:null,
  //       },
		data(){
			return{
				
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){
			
		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../less/index.less';
	.test_result_structure{
		
	}
</style>	


// WEBPACK FOOTER //
// src/components/testResultStructure.vue